import React from 'react';
import PropTypes from 'prop-types';
import _ from 'underscore';

import { ReactTemplate } from '@bingads-webui-react/react-template';
import { RadioGroup } from '@bingads-webui-react/radio';
import { CustomerListFilePicker } from './file-picker';
import { stringKeys, hashOptions, fileTemplateLink, fileHashedTemplateLink } from '../common/constants';

const StyleForUploadSelector = {
  display: 'flex',
  flexDirection: 'column',
  gap: '10px',
};

export class UploadSelector extends React.PureComponent {
  static propTypes = {
    i18n: PropTypes.shape({
      getString: PropTypes.func.isRequired,
      parseDecimal: PropTypes.func.isRequired,
    }).isRequired,
    onHashSelectionChanged: PropTypes.func.isRequired,
    onFileChangedAsync: PropTypes.func.isRequired,
    templatePath: PropTypes.string.isRequired,
  };

  state = {
    hashSelection: hashOptions.plainText,
  };

  onHashSelectionChanged = (hashOption) => {
    this.setState({
      hashSelection: hashOption,
    });

    this.props.onHashSelectionChanged(hashOption);
    this.props.onFileChangedAsync(null);
  };

  renderUploadSelectorItem = (item) => {
    const filePicker = (
      <div>
        <CustomerListFilePicker
          i18n={this.props.i18n}
          onFileChangedAsync={this.props.onFileChangedAsync}
        />
      </div>
    );

    return (
      <div
        className="customer-list-option-content"
        style={StyleForUploadSelector}
      >
        <div>
          {this.props.i18n.getString(item.titleStringKey)}
        </div>
        <div>
          {this.props.i18n.getString(item.descriptionStringKey)}
        </div>
        <div>
          <ReactTemplate
            model={{ templateLink: this.renderTemplateLink(item) }}
            template={this.props.i18n.getString(stringKeys.fileUploadNotice)}
          />
        </div>
        {this.state.hashSelection === item ? filePicker : null}
      </div>
    );
  };

  renderTemplateLink = (item) => {
    const showHashedLink = item && item.isHashed;
    return (
      <a href={`${this.props.templatePath}${showHashedLink ? fileHashedTemplateLink : fileTemplateLink}`} target="_blank" rel="noopener noreferrer">
        {this.props.i18n.getString(stringKeys.itemTemplate)}
      </a>
    );
  };

  render() {
    return (
      <div className="customer-list-upload-selector">
        <span>
          <ReactTemplate
            model={{ templateLink: this.renderTemplateLink() }}
            template={this.props.i18n.getString(stringKeys.fileUploadInstruction)}
          />
        </span>
        <RadioGroup
          items={_.values(hashOptions)}
          onChange={this.onHashSelectionChanged}
          name="customer-list-upload-selector-x"
          checked={this.state.hashSelection}
          renderItem={this.renderUploadSelectorItem}
        />
      </div>
    );
  }
}
